import { useEffect } from 'react';

/**
 * React hook for listening to a mutation observer on an HTML node
 * @param options UseMutationObserverOptions
 * @return void
 */
var useMutationObserver = function useMutationObserver(options) {
  var callback = options.callback,
    _options$mutationObse = options.mutationObserverOptions,
    mutationObserverOptions = _options$mutationObse === void 0 ? {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    } : _options$mutationObse,
    node = options.node,
    ref = options.ref;
  useEffect(function () {
    if (node) {
      var observer = new MutationObserver(callback);
      observer.observe(node, mutationObserverOptions);
      return function () {
        observer.disconnect();
      };
    }
    return;
  }, [node]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (ref !== null && ref !== void 0 && ref.current) {
      var observer = new MutationObserver(callback);
      observer.observe(ref.current, mutationObserverOptions);
      return function () {
        observer.disconnect();
      };
    }
    return;
  }, [ref === null || ref === void 0 ? void 0 : ref.current]); // eslint-disable-line react-hooks/exhaustive-deps
};

export { useMutationObserver };